export const tableMixin = {
    beforeMount() {
    },
    data() {
        return {
            columns: [
            {
                label: 'Name',
                field: 'user',
            },
            {
                label: 'Amount',
                field: 'amount',
                type: 'number',
            },
            {
                label: 'Reason',
                field: 'reason',
            },
            {
                label: 'Phone Number',
                field: 'recieversnumber',
            },
            {
                label: 'Created On',
                field: 'date',
            },
            {
                label: 'Status',
                field: 'status',
            },
            {
                label: 'Actions',
                field: 'actions'
            },
        ],
            rows: [],
            requests: [],
            users: [],
             // Add a data property for the search query
        };
    },
    methods:{
        searchUsers(search, loading) {
            if (loading) {
                loading(true)
            }
            return this.$store.dispatch(`searchUsers`, search)
                .then(res => this.users = res)
                .finally(() => {
                    if (loading) {
                        loading(false)
                    }
                });
        },
        myFunction() {
            // Get the text field
            var copyText = document.getElementById("myInput");

            // Select the text field
            copyText.select();
            copyText.setSelectionRange(0, 99999); // For mobile devices

            // Copy the text inside the text field
            navigator.clipboard.writeText(copyText.value);

            // Alert the copied text
            alert("Copied the text: " + copyText.value);
        },
    }
}